export const CHATBOT_API_VERSION = '/api/v1/';

const CHATBOT_APIS: { [key: string]: string } = {
  helpURL: `/Minerva Help.pdf`,
  legalTermsURL: `/Water_Solutions_Digital_Terms_and_Conditions.pdf`,
  contactUsURL: `https://www.dupont.com/water/contact-us.html?src=ws_global_web_minerva_web_leadgen_2025`,
  privacyURL: `https://www.dupont.com/privacy.html`,
  waterResourceURL: `https://www.dupont.com/resource-center.html?BU=water`,
  promptsURL: `/chatbot/prompts`,
  chatsHistoryURL: `/chat-history`,
  queryURL: `/chatbot/query`,
  chatHistoryDetailURL: `/chat-history/{history_id}`,
  chatFeedbackURL: `/chat-history/{history_id}/chats/{chat_id}/feedback`,
  chatReviewURL: `/chat-history/{history_id}/chats/{chat_id}/review`,
  settingsURL: `/users/settings/{setting_id}`,
  reportLogin: `/users/report-login`,
  updateChatTitleURL: `/chat-history/{%id}/title`,
  adminChatsURLs: `/admin/chats`,
  adminChatsExportURL: `/admin/chats/export`,
};

export default CHATBOT_APIS;
